const Loading = () => {
  return (
    <div className="lds-circle">
      <div></div>
    </div>
  );
};

export default Loading;
